module.exports = __webpack_public_path__ + "static/NOI1-555ad531471bcaf08ae979c76f5388b4.png";